import { TextLinkWidget, TextLinkKind } from '@tableau/widgets';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Messages } from '../../../../../gen-src/Localize';
import { SiteUrlsContext } from '../urls/SiteUrlsContext';
import { LabelButtonContext, buildLineagePath, LabelsPopoverContext } from './LabelHelpers';
import { LabelSubjectArea } from './shared/LabelAssetContent';

const VIEW_LINEAGE_BUTTON_TEST_ID = 'view_lineage_button';

export function ViewLineageButton({ contentType }: {
  contentType: LabelSubjectArea | null
}) {
  const { linksDisabled } = React.useContext(LabelButtonContext);
  const { content } = React.useContext(LabelsPopoverContext);
  const siteUrls = React.useContext(SiteUrlsContext);
  const location = useLocation();
  const onLineageTab = location.pathname.includes('lineage');

  if (content?.subjectArea === undefined || content.contentId === undefined || content.contentId === '') {
    return <></>
  }

  const lineagePath = buildLineagePath(siteUrls, content?.subjectArea, content.contentId);
  const showButton = !onLineageTab && lineagePath.length > 0;

  switch (contentType) {
    case 'Column': case 'column':
    case 'Field': case 'FlowColumnOutputField': case 'FlowFieldOutputField':
      return (
        showButton ? <TextLinkWidget
          href={linksDisabled ? '' : lineagePath}
          testId={VIEW_LINEAGE_BUTTON_TEST_ID}
          style={{ float:'right' }}
          target='_self'
          kind={TextLinkKind.Standalone}>
          {Messages.Label_view_lineage_button()}
        </TextLinkWidget>
          : <></>
      );
    default:
      return <></>
  }
}
